import React, { useState, useEffect, useRef } from 'react';
import classes from './HeaderNav.module.css';
import logo from '../../../Assets/rotating-logo.png';
import icon from '../../../Assets/Component 1 (4).png';
import iconinactive from '../../../Assets/dshbrd-inactive.png';
import trsanstin from '../../../Assets/cardtrsnct.png';
import RotatingLogo from '../../../Assets/rotating-logo.png'
import trsanstinactive from '../../../Assets/Component 1 (3).png';
import acctn from '../../../Assets/Accountingicon.png';
import acctnactive from '../../../Assets/Component 1 (2).png';
import rprts from '../../../Assets/reportsicon.png';
import rprtsactive from '../../../Assets/Component 1 (6).png';
import bnkn from '../../../Assets/bankin-icon.png';
import bnknactive from '../../../Assets/Component 1 (7).png';
import stngs from '../../../Assets/settings-icon.png';
import stngsactive from '../../../Assets/Component 1 (8).png';
import CurrencyInput from 'react-currency-input-field';
import { Dropdown, Col, Row, Button, Modal, Form, Spinner, Badge } from 'react-bootstrap';
import Select from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaBars, FaTimes } from "react-icons/fa";
import { CiMenuFries } from "react-icons/ci";
import { FaRegTimesCircle } from "react-icons/fa";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import JournalModal from "./Journal/Journal";

import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../Components/Styles/API/API';
import RemitanceUpload from './Journal/RemittanceUpload';


const permissionToMenuMap = {
  'Manage Setup': {
    menu: 'Administration', path: ['/admin/continent',
      '/admin/region',
      '/admin/province',
      '/admin/manage_user',
      '/admin/complianceProvince',
      '/admin/auditProvince',
      '/admin/months']
  },

  'Manage Receivables': {
    menu: 'Operations', paths: [
      '/accounting/customers',
      '/accounting/remitances',
      '/admin/operations/account',
      // '/accounting/loan',
      // // '/accounting/receivables/staff_loan',
      // '/accounting/receivables/repayment_schedule',
      // '/accounting/customers_receipts',
      // '/accounting/customers_ledger',
      // '/accounting/loan_ledger',
      // '/accounting/outstanding_remittance_schedule',
      // '/accounting/schedule_of_receivable'
    ]
  },
  'Manage Payables': {
    menu: 'Transactions', paths: [
      '/accounting/supplier',
      // '/accounting/purchase_invoices',
      '/accounting/monthly_payable_upload',
      '/accounting/suppliers_personal_ledger',
      // '/accounting/schedule_of_payable'
    ]
    // },
    // 'Manage Payables': {
    //   menu: 'Province Records', paths: [
    //     '/accounting/supplier',

    //     '/accounting/monthly_payable_upload',
    //     '/accounting/suppliers_personal_ledger',

    //   ]
  },
  'Manage Receipts': {
    menu: 'Accounts', paths: [

      '/accounting/cash_management',
      '/accounting/cash_movement',
      '/accounting_cashmovement',

      //   '/payment/petty_cash' ,
      // '/payment/petty_cash_bulk_entries' ,
      //   '/account_payment_voucher' ,
      '/account_payables_bulk',
      '/cash_management/bank_lodgement/pending',
      '/cash_management/lodged_transactions',
      // '/accounting/budgets' ,
      //   '/accounting/payroll' ,
      '/payment/expenses',
      // '/account_payables_bulk'
    ]
  },
  'Manage Payments': {
    menu: 'Financial Statements', paths: [
      '/account_payables_bulk',
      'accounting/loan_disbursement'
    ]
  },

  'Manage Accountings': {
    menu: 'Accounting', paths: [
      '/accounting/view_journal_entries',
      '/accounting/search_account_journals',
      '/accounting/upload_opening_balance',
      '/accounting/upload_opening_balance_bulk',
      '/accounting/upload_journal_entry',
      '/accounting/national/upload_journal_entry',
      '/accounting/charts_of_account/account',
      '/accounting/account_approvals',
      '/accounting/account_dispproved'
    ]
  },
  'Manage Reports': {
    menu: 'Reports', paths: [
      'accounting/report'
      // '/accounting/cashbook',
      // '/accounting/trial_balance',
      // '/accounting/income_statement_summary',
      // '/accounting/income_statement_detailed',
      // '/accounting/activity_report_acct',
      // '/accounting/aged_analysis_payables',
      // '/accounting/aged_analysis_receivables',
      // '/financial_position',
      // '/accounting/statement_of_financial_position_admin',
      // '/accounting/bank_report',
      // '/accounting/sales_report',
      // '/accounting/purchase_report'
    ]
  },
};

export default function HeaderNav() {
  const location = useLocation();
  const [teller, setTeller] = useState("")
  const [user, setUser] = useState('');
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState('');
  const userDropdownRef = useRef(null);
  const [showRemittanceExcelModal, setShowRemittanceExcelModal] = useState(false);
  const [showRemittanceModal, setShowRemittanceModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const navigate = useNavigate();
  const [monthLoading, setMonthLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [show2648, setShow2648] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [createLoading, setCreateLoading] = useState(false);
  const [bearer, setBearer] = useState('');
  const [company, setCompany] = useState('');
  const [userType, setUserType] = useState('');
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [continent, setContinent] = useState('');
  const [region, setRegion] = useState('');
  const [interest, setInterest] = useState(0.00);
  const [totalRepayment, setTotalRepayment] = useState(0.00);
  const [monthlyDeduction, setMonthlyDeduction] = useState('');
  const [duration, setDuration] = useState('');
  const [province, setProvince] = useState('');
  const [validity, setValidity] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [permits, setPermits] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [admin, setAdmin] = useState('');
  const [description, setDescription] = useState("");
  const [outstanding, setOutstanding] = useState("");
  const [currMonth, setCurrMonth] = useState('');
  const [loading, setLoading] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [loans, setLoans] = useState([]);
  const [openJournalModal, setOpenJournalModal] = useState(false);

  const toggleNav = () => setNavOpen(!navOpen);
  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption.value);
    setOutstanding(selectedOption.balance);
  };
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value1 = await localStorage.getItem('tobi');
      const value9 = await localStorage.getItem('userEmail');
      const value2 = await localStorage.getItem('allPermissions');
      const value3 = await localStorage.getItem('admin');
      const value7 = await localStorage.getItem('companyName');
      const value8 = await localStorage.getItem('validity');
      const curr = await localStorage.getItem('currentMonth');
      const permitsss = await localStorage.getItem('modules');

      if (value !== null && value.trim() !== '') {
        setBearer(value);
      } else {
        navigate('/login');
        return;
      }
      if (value2 !== null) {
        // const parsedPermitions = JSON.parse(value2);
        // const permitionNames = parsedPermitions.map((permit) => permit.name);
        setPermissions(value2);
        console.log(value2);
      }
      if (permitsss !== null) {
        const parsedPermits = JSON.parse(permitsss);
        const permitNames = parsedPermits.map((permit) => permit.name);
        setPermits(permitNames);
        console.log('Parsed Permissions:', parsedPermits);
      }
      if (value1 !== null) {
        setUser(value1);
      }
      if (value9 !== null) {
        setUserEmail(value9);
      }
      if (value8 !== null) {
        setValidity(value8);
      }
      if (value3 !== null) {
        setAdmin(value3);
      }
      if (value7 !== null) {
        setCompany(value7);
      }
      if (curr !== null) {
        console.log(curr);
        const date = new Date(curr);

        setCurrMonth(date);

        const startOfDateRange = new Date(1900, 0, 1);

        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));

        console.log("Date Range:", formatDate(startOfDateRange), "to", formatDate(endOfDateRange));
      }
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${bearer}`,
  };
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const handlePaymentModeChange = (event) => {
    setSelectedPaymentMode(event.target.value);
  };
  const [paymentMethod, setPaymentMethod] = useState([]);

  const fetchPaymentMethod = async () => {
    setLoading(true);


    try {
      const response = await axios.get(`${BASE_URL}/income/get-payment-method`,
        {

          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );
      const resultss = response.data?.data;
      setPaymentMethod(resultss);

      console.log(resultss, "PaymentModes");
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  const [incomeAmount, setIncomeAmount] = useState();
  const handleValueChanges = (value) => {
    setIncomeAmount(value);
  };

  const navItems = [
    { label: 'Dashboard', path: '/accounting', icon: iconinactive, activeIcon: icon },
    { label: 'Administration', path: '/accounting/continent', icon: stngs, activeIcon: stngsactive },
    { label: 'Operations', path: '/accounting/customers', icon: trsanstin, activeIcon: trsanstinactive },
    { label: 'Transactions', path: '/accounting/supplier', icon: acctn, activeIcon: acctnactive },
    // { label: 'Province Records', path: '/accounting/supplier', icon: acctn, activeIcon: acctnactive },
    { label: 'Accounts', path: '/budget/account_category', icon: bnkn, activeIcon: bnknactive },
    { label: 'Reports', path: '/budget/finance-statement', icon: bnkn, activeIcon: bnknactive },
    // { label: 'Accounting', path: '/accounting/view_journal_entries', icon: acctn, activeIcon: acctnactive },
    // { label: 'Reports', path: '/accounting/report', icon: rprts, activeIcon: rprtsactive },
  ];

  const dropdownMenus = {
    Administration: [
      { label: 'Manage Currency Rate', path: '/admin/exchange_rate', permission: 'Manage Setup' },
      { label: 'Manage Tax', path: '/admin/Tax', permission: 'Manage Setup' },
      { label: 'Manage Continents', path: '/admin/continent', permission: 'Manage Setup' },
      { label: 'Manage Regions', path: '/admin/region', permission: 'Manage Setup' },
      { label: 'Manage Province', path: '/admin/province', permission: 'Manage Setup' },
      { label: 'Manage User', path: '/admin/manage_user', permission: 'Manage Setup' },
      { label: 'Compliance-Province Assignment ', path: '/admin/complianceProvince', permission: 'Manage Setup' },
      // { label: 'Accountant- Province Assignment ', path: '/admin/accountant_province', permission: 'Manage Setup' },
      { label: 'Audit-Province Assignment ', path: '/admin/auditProvince', permission: 'Manage Setup' },

    ],
    Operations: [
      { label: 'Change Working Month ', path: '/admin/change_working_month_approvals', permission: 'Manage Receivables' },
      // { label: 'Reverse Working Month Approval', path: '/accounting/remitances', permission: 'Manage Receivables' },
      // { label: 'Monthly Remitance Upload - Excel', path: '/accounting/upload_remitance_excel', permission: 'Manage Receivables' },
      // { label: 'Approved Working Month Approval', customAction: () => setOpenJournalModal(true), permission: 'Manage Receivables' },
      // { label: 'Disapproved Working Month Approval', path: '/accounting/loan', permission: 'Manage Receivables' },
      { label: 'Reset Working Month', path: '/accounting/reset_working_month', permission: 'Manage Receivables' },
      { label: 'Account Approvals', path: '/admin/operations/account', permission: 'Manage Receivables' },
      { label: 'Change Working Month(Approval)', path: '/admin/change_working_month_approval',  permission: 'Manage Receivables' },
      { label: 'Change Working Month(Disapprove)', path: '/admin/change_working_month_disapprove',  permission: 'Manage Receivables' },
      { label: 'Change Working Month(Pending)', path: '/admin/change_working_month_pending', permission: 'Manage Receivables'  },
      // { label: "Approved Accounts", path: '/accounting/customers_receipts', permission: 'Manage Receivables' },
      // { label: "Approved Transactions", path: '/accounting/customers_ledger', permission: 'Manage Receivables' },
      // { label: "Staff Personal Ledger", path: '/accounting/staff_personal_ledger', permission: 'Manage Receivables' },
      // { label: "Loan Ledger", path: '/accounting/loan_ledger', permission: 'Manage Receivables' },
      // { label: "Outstanding Remittance Schedule", path: '/accounting/outstanding_remittance_schedule', permission: 'Manage Receivables' },
      // { label: 'Schedule of Receivables', path: '/accounting/schedule_of_receivable', permission: 'Manage Receivables' },
    ],
    'Transactions': [
      { label: 'Receipts', path: '/admin/cash_management', permission: 'Manage Payables' },
      { label: 'Expenses', path: '', permission: 'Manage Payables' },
      { label: 'Lodged Transactions', path: '', permission: 'Manage Payables' },
      { label: 'Budget', path: '', permission: 'Manage Payables' },
      { label: 'Payroll', path: '', permission: 'Manage Payables' },
      // { label: 'Contractors/Suppliers Invoices', path: '/accounting/contractor_invoices', permission: 'Manage Payables' },
      // // { label: 'Payable Invoices', path: '/accounting/purchase_invoices', permission: 'Manage Payables' },
      // // { label: 'Upload Payables', isUploadPayableModal: true, permission: 'Manage Payables' },
      // { label: "Payable Entries", path: '/accounting/payable_entries', permission: 'Manage Payables' },
      // { label: "Payable Approval", path: '/account_payables_payment', permission: 'Manage Payables' },
      // { label: "Salary Payable Entries", path: '/accounting/salary_payables_entries', permission: 'Manage Payables' },
      // { label: "Suppliers' Personal Ledger", path: '/accounting/suppliers_ledger', permission: 'Manage Payables' },
      // { label: 'Schedule of Payables', path: '/accounting/schedule_of_payable', permission: 'Manage Payables' },
    ],
    // 'Province Records': [
    //   { label: 'Customers', path: '/accounting/supplier', permission: 'Manage Payables' },
    //   { label: 'Supppliers', path: '/accounting/paye', permission: 'Manage Payables' },
    //   { label: 'Charts of Accounts', path: '/accounting/hmo', permission: 'Manage Payables' },
    //   { label: 'Loan Beneficiaries', path: '/accounting/pension', permission: 'Manage Payables' },
    //   { label: 'Upload Budget', path: '/accounting/paye_invoices', permission: 'Manage Payables' },

    // ],
    Accounts: [
      { label: 'Account Category', path: '/budget/account_category' },
      // { label: 'Chart of Accounts', isRemittanceModal: true },
      // { label: 'Remittances - Excel Upload', isUploadRemittanceExcel: true },
      { label: 'Chart of Accounts', path: '/budget/chart_of_account' },
      // { label: 'Bank Lodgement', path: '/cash_management/bank_lodgement/pending' },
      // { label: 'Lodged Transactions', path: '/cash_management/lodged_transactions' },
    ],
    'Reports': [
      { label: "Financial Report", path: '/budget/finance-statement' },
      { label: "Provincial Record", path: '/account_payments' },
      { label: "Province Status Report", path: '/provincestatus_reports' },
      // { label: "Pending Payments", path: '/account_approved_payables' },
      // { label: "Cheque Payments", path: '/cheque_payments' },
      // { label: "Payment Instructions", path: '/payment_instructions' },
    ],
    Accounting: [
      { label: 'Journal Entries', path: '/accounting/view_journal_entries', permission: 'Manage Journal Entries' },
      { label: 'Search Account Journal', path: '/accounting/search_account_journals', permission: 'Search Account Journal' },
      { label: 'Upload Opening Balance - Excel', path: '/accounting/upload_opening_balance', permission: 'Upload Opening Balance (Excel)' },
      { label: 'Upload Opening Balance - Bulk', path: '/accounting/upload_opening_balance_bulk', permission: 'Upload Opening Balance (Bulk)' },
      { label: 'Upload Journal Entry', path: '/accounting/upload_journal_entry', permission: 'Upload Journal Entry' },
      { label: 'Upload National Journal Entry', path: '/accounting/national/upload_journal_entry', permission: 'Upload National Journal Entries' }, // 👈 requires this exact permission
      { label: 'Charts of Account', path: '/accounting/charts_of_account/account', permission: 'Manage Charts of Account' },
      { label: 'Pending Account Approvals', path: '/accounting/account_approvals', permission: 'Manage Pending Account Approvals' },
      { label: 'Disapproved Account', path: '/accounting/account_dispproved', permission: 'Manage Disapproved Accounts' },
    ],

    // Reports: [
    //   { label: 'Cashbook', path: '/accounting/cashbook', permission: 'Manage Reports' },
    //   { label: 'Trial Balance', path: '/accounting/trial_balance', permission: 'Manage Reports' },
    //   { label: 'Income Statement - Summary', path: '/accounting/income_statement_summary', permission: 'Manage Reports' },
    //   { label: 'Income Statement - Detailed', path: '/accounting/income_statement_detailed', permission: 'Manage Reports' },
    //   { label: 'Account Activity Report', path: '/accounting/activity_report_acct', permission: 'Manage Reports' },
    //   { label: 'Age Analysis - Payables', path: '/accounting/aged_analysis_payables', permission: 'Manage Reports' },
    //   { label: 'Age Analysis - Receivables', path: '/accounting/aged_analysis_receivables', permission: 'Manage Reports' },
    //   { label: 'Statement of Financial Position - Summary', path: '/financial_position', permission: 'Manage Reports' },
    //   { label: 'Statement of Financial Position - Detailed', path: '/accounting/statement_of_financial_position_admin', permission: 'Manage Reports' },
    //   { label: 'Bank Position Summary', path: '/accounting/bank_report', permission: 'Manage Reports' },
    //   { label: 'Sales Report', path: '/accounting/sales_report', permission: 'Manage Reports' },
    //   { label: 'Purchases Report', path: '/accounting/purchase_report', permission: 'Manage Reports' },
    // ],
  };

  // Filter navItems based on permissions
  const filteredNavItems = navItems.filter((item) => {
    if (item.label === 'Dashboard') return true; // Dashboard is always visible
    const menuPermissions = Object.keys(permissionToMenuMap).filter((perm) => permissionToMenuMap[perm].menu === item.label);
    return menuPermissions.some((perm) => permissions.includes(perm));
  });

  useEffect(() => {
    const handleClickOutside = (e) => {
      const dropdownContainer = document.querySelector(`.${classes.dropdown}`);
      if (dropdownContainer && !dropdownContainer.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // const handleLogout = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       `${BASE_URL}/logout`,
  //       {},
  //       { headers }
  //     );
  //     navigate('/login');
  //   } catch (error) {
  //     let errorMessage = 'An error occurred. Please try again.';
  //     if (error.response && error.response.data && error.response.data.message) {
  //       if (typeof error.response.data.message === 'string') {
  //         errorMessage = error.response.data.message;
  //       } else if (Array.isArray(error.response.data.message)) {
  //         errorMessage = error.response.data.message.join('; ');
  //       } else if (typeof error.response.data.message === 'object') {
  //         errorMessage = JSON.stringify(error.response.data.message);
  //       }
  //     }
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Failed',
  //       text: errorMessage,
  //     });
  //     console.log(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleLogout = () => {
    navigate('/');
  };

  const changePassword122 = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/change_password`,
        {
          current_password: currentPassword,
          new_password: password,
          password_confirmation: passwordConfirmation,
        },
        { headers }
      );
      setCurrentPassword('');
      setPassword('');
      setPasswordConfirmation('');
      setShow(false);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: errorMessage,
      });
    } finally {
      setCreateLoading(false);
    }
  };

  const getNextMonthName = (currMonth) => {
    // Parse the currMonth string to create a Date object
    const date = new Date(currMonth);

    // Extract the current month (0-based index, so adding 1 to get the next month)
    let nextMonth = date.getMonth() + 1; // getMonth() is 0-based (Jan = 0)

    // If the next month is December (11) and we need to roll over to January
    if (nextMonth > 11) {
      nextMonth = 0;
    }

    // Create a new date object for the next month (day set to 1 for simplicity)
    const nextMonthDate = new Date(date.getFullYear(), nextMonth, 1);

    // Use toLocaleString() to get the month name in words
    const nextMonthName = nextMonthDate.toLocaleString("default", {
      month: "long",
    });

    return nextMonthName;
  };

  const getPrevMonthName = (currMonth) => {
    // Parse the currMonth string to create a Date object
    const date = new Date(currMonth);

    // Extract the current month and subtract 1 to get the previous month
    let prevMonth = date.getMonth() - 1; // getMonth() is 0-based (Jan = 0)

    // If the previous month is before January, roll over to December of the previous year
    if (prevMonth < 0) {
      prevMonth = 11; // December
      date.setFullYear(date.getFullYear() - 1); // Move to the previous year
    }

    // Create a new date object for the previous month (day set to 1 for simplicity)
    const prevMonthDate = new Date(date.getFullYear(), prevMonth, 1);

    // Use toLocaleString() to get the month name in words
    const prevMonthName = prevMonthDate.toLocaleString("default", {
      month: "long",
    });

    return prevMonthName;
  };

  const getCurrentMonthName = (currMonth) => {
    // Parse the currMonth string to create a Date object
    const date = new Date(currMonth);

    // Use toLocaleString() to get the current month name in words
    const currentMonthName = date.toLocaleString("default", { month: "long" });

    return currentMonthName;
  };


  useEffect(() => {
    if (bearer) {
      fetchPaymentMethod();

    }
  }, [bearer]);

  const [isLoading, setIsLoading] = useState(false);
  const [loanInterest, setLoanInterest] = useState(0.00);
  const [cus, setCus] = useState([]);

  const fetchSupplierss = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers`, { headers });
      console.log(response)
      // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
      const results = response.data?.data?.data;
      console.log("results:", results)
      const options = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCustomers([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCustomers = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
      console.log(response)
      // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
      const results = response.data?.data;
      console.log("results:", results)
      const options = results.map((item) => ({
        label: item.name,
        value: item.id,
        balance: item.balance
      }));
      setCus(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setCus([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLoans = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
      const results = response.data?.data;

      const options1 = results.map((item) => ({
        label: item.description,
        value: item.id,
        interest: item.interest
      }));
      setLoans(options1);
      // setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoans([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchSupplierss();
      fetchLoans();
      fetchCustomers();
    }
  }, [bearer]);

  const [selectedLoan, setSelectedLoan] = useState(null);



  const handleLoanTypeChange = (selectedOption) => {
    setSelectedLoan(selectedOption.value);
    const selectedLoanInterest = selectedOption.interest;
    setLoanInterest(selectedLoanInterest === null ? "0.00" : selectedLoanInterest);
  };

  const handleTrashClick1 = async () => {
    const currentMonthName = getCurrentMonthName(currMonth);
    const nextMonthName = getNextMonthName(currMonth);
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to change your working month from ${currentMonthName} to ${nextMonthName}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Change it!",
      cancelButtonText: "No, Cancel",
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
    Swal.fire({
      title: "Changing the working month...",
      text: "Please wait while we process your request.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the confirm button
      didOpen: () => {
        Swal.showLoading(); // Show loading spinner
      },
    });

    setMonthLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/update-province-month`,
        {}, // Empty body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      // Close the loading Swal and show the success message
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });
      navigate("/login");
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }

      // Close the loading Swal and show the error message
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setMonthLoading(false); // Stop loading
    }
  };

  const handleTrashClick2 = async () => {
    const currentMonthName = getCurrentMonthName(currMonth);
    const prevMonthName = getPrevMonthName(currMonth);
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `You are about to reset your working month from ${currentMonthName} to ${prevMonthName}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
      cancelButtonText: "No, Cancel",
    });

    if (!confirmed.isConfirmed) {
      return; // User canceled, do nothing
    }

    // Show a Swal saying "Changing the working month, please wait..." and prevent interaction
    Swal.fire({
      title: "Resetting the working month...",
      text: "Please wait while we process your request.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false, // Hide the confirm button
      didOpen: () => {
        Swal.showLoading(); // Show loading spinner
      },
    });

    setMonthLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}/provinces/reverse-province-month`,
        {}, // Empty body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearer}`,
          },
        }
      );

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      });
      navigate("/login");
      //   setTrashClicked1(true);
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: errorMessage,
      });
      console.log(error);
    } finally {
      setMonthLoading(false); // Stop loading
    }
  };

  const getInitials = (name) => {
    const parts = name?.trim().split(' ');
    const firstTwo = parts?.slice(0, 2);
    return firstTwo.map((part) => part.charAt(0).toUpperCase()).join('');
  };

  const initials = getInitials(user);

  const [showLoanModal, setShowLoanModal] = useState(false);
  const handleClose = () => {
    setShowLoanModal(false);
  };

  const [showCustomer, setShowCustomer] = useState(false);
  const handleCloseCustomer = () => setShowCustomer(false);
  const handleShowCustomer = () => {
    setShowCustomer(true);
    handleClose();
  }
  const [selectedImage, setSelectedImage] = useState('');

  const createLoans = async () => {
    setLoading(true);

    try {

      const formData = new FormData();
      formData.append('doc', selectedImage);
      // formData.append("bank", selectedBank);
      formData.append("loan_name", selectedLoan);


      const response = await axios.post(
        `${BASE_URL}/account/upload-staff-loan-payment`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      // setBalances(response.data.data);
      handleCloseCustomer();
      // Reset form fields
      setSelectedImage("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      }).then(() => {
        window.location.reload();
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const [selectedDatess, setSelectedDatess] = useState('');
  const handleDateChangess = (event) => {
    setSelectedDatess(event.target.value);
  };

  const handleSupplierChange = (selectedOption) => {
    setSelectedCustomer(selectedOption.value);
  }

  const [principalAmount, setPrincipalAmount] = useState('');

  const handleValueChange = (value, name, values) => {
    setPrincipalAmount(value);
  };

  const handleValueChange1 = (value, name, values) => {
    setLoanInterest(value);
  };

  const handleValueChange2 = (value, name, values) => {
    setInterest(value);
  };

  const [banks, setBanks] = useState([]);
  const [selectedBanks, setSelectedBanks] = useState(null)

  const handleBankChange = (selectedOption) => {
    setSelectedBanks(selectedOption);
  }
  const fetchBanks = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
      const results = response.data?.data;

      const options1 = results.map((item) => ({
        label: item.gl_name,
        value: item.id,
      }));
      setBanks(options1);
      // setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setBanks([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {

      fetchBanks();

    }
  }, [bearer]);
  const handlePaymentChange = (selectedOption) => {
    if (selectedOption) {
      const selectedValue = selectedOption.value; // Access the value here
      console.log('Selected value:', selectedValue); // For debugging
      // Set the selected payment mode or perform any other action you need
      // setSelectedPaymentMode(selectedValue); // Assuming you're updating the payment mode

      setSelectedBanks(selectedValue);

    } else {
      console.error('Selected option is undefined');
    }
  };


  const handleValueChange3 = (value, name, values) => {
    setTotalRepayment(value);
  };

  const handleValueChange4 = (value, name, values) => {
    setMonthlyDeduction(value);
  };


  useEffect(() => {
    const calculateInterestRate = () => {
      const calculatedInterestRate = (parseFloat(loanInterest) / 100) * parseFloat(principalAmount);
      const formattedInterestRate = isNaN(calculatedInterestRate) ? "0.00" : calculatedInterestRate.toFixed(2);

      setInterest(formattedInterestRate);
    };

    calculateInterestRate();
  }, [loanInterest, principalAmount]);


  useEffect(() => {
    const calculateTotalRepayment = () => {
      const calculatedTotalRepayment = parseFloat(principalAmount) + parseFloat(interest);
      const formattedTotalRepayment = isNaN(calculatedTotalRepayment) ? "0.00" : calculatedTotalRepayment.toFixed(2);

      setTotalRepayment(formattedTotalRepayment);
    };

    calculateTotalRepayment();
  }, [interest, principalAmount]);

  useEffect(() => {
    const calculateReturn = () => {
      const calculatedReturn = parseFloat(totalRepayment) / parseFloat(duration);
      const formattedReturn = isNaN(calculatedReturn) ? "0.00" : calculatedReturn.toFixed(2);

      setMonthlyDeduction(formattedReturn);
    };

    calculateReturn();
  }, [totalRepayment, duration]);




  const createLoan = async () => {
    setCreateLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/account/staff-loan`,
        {
          member_name: selectedCustomer || '',
          loan_name: selectedLoan || '',
          bank: selectedBanks.value,
          principal_amount: principalAmount,
          interest_amount: interest,
          total_repayment: totalRepayment,
          monthly_deduction: monthlyDeduction,
          loan_interest: loanInterest,
          duration: duration,
          transaction_date: selectedDatess,
          // cheque_number: cheque


        },
        { headers }
      );
      console.log(response.data.message)
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: response.data.message,
      });
      handleClose();

      setSelectedCustomer(null);
      setSelectedLoan(null);
      setSelectedBanks(null);
      // setSelectedDate('');
      setSelectedDatess('');
      setPrincipalAmount('');
      setLoanInterest('');
      setInterest('');
      setTotalRepayment('');
      // setCheque('');
      setDuration('');
      setMonthlyDeduction('');

      // navigate('/loans_advances')

      // return
      //   Swal.fire({
      //     icon: 'success',
      //     title: 'Success',
      //     text: response.data.message,
      //   });
      //   console.log(response.data);

      // } catch (error) {
      //   const errorStatus = error.response.data.message;
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Failed',
      //     text: errorStatus,
      //   });
      //   console.log(error);

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          console.log(error.response.data.message);
        }
      }
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: JSON.stringify(error.response.data.data),
      });
    } finally {
      setCreateLoading(false);
    }
  };

  // Upload Payables modals
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [payableType, setPayableType] = useState(""); // "Salary" or "Pension"
  const handleOpenUploadType = () => setShowTypeModal(true);
  const handleCloseTypeModal = () => setShowTypeModal(false);

  const handleSelectType = (type) => {
    setPayableType(type);
    setShowTypeModal(false);
    setShowFormModal(true);
  };

  const handleCloseFormModal = () => {
    setShowFormModal(false);
    setPayableType("");
  };


  const [debit1, setDebit1] = useState([]);
  const [debit2, setDebit2] = useState([]);
  const [debit3, setDebit3] = useState([]);
  const [debit4, setDebit4] = useState([]);

  const fetchDebit1 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });

      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,


      }));
      setDebit1(oopt1);



    } catch (error) {
      const errorStatus = error.response.data.message;
      // console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };
  const fetchDebit3 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });

      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,


      }));
      setDebit3(oopt1);



    } catch (error) {
      const errorStatus = error.response.data.message;
      // console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  const fetchDebit2 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/payables`, { headers });

      const debt2 = response.data?.data;
      const oopt2 = debt2.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,


      }));
      setDebit2(oopt2);



    } catch (error) {
      const errorStatus = error.response.data.message;
      // console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };
  const fetchDebit4 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash`, { headers });

      const debt2 = response.data?.data;
      const oopt2 = debt2.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,


      }));
      setDebit4(oopt2);



    } catch (error) {
      const errorStatus = error.response.data.message;
      // console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchDebit1();
      fetchDebit2();
      fetchDebit3();
      fetchDebit4();
    }
  }, [bearer]);

  const [selectedExpenses, setSelectedExpenses] = useState('')
  const [date, setDate] = useState('')
  const [selectedImagesss, setSelectedImagesss] = useState('');
  const [selectedPayable, setSelectedPayable] = useState('')

  const handleImageChangessss = (event) => {
    const file = event.target.files[0];
    setSelectedImagesss(file);
  };
  const handledExpenses = (selectedOption) => {
    setSelectedExpenses(selectedOption.value);
  };
  const handlePayables = (selectedOption) => {
    setSelectedPayable(selectedOption.value);
  };
  const [tableData, setTableData] = useState([]);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState('');

  const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      console.log(response);
      setTableData(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchCharts();

    }
  }, [bearer]);

  const uploadStatement = async () => {
    setCreateLoading(true);

    try {

      const formData = new FormData();
      formData.append('file', selectedImagesss);
      formData.append('payable', selectedPayable);
      formData.append('expense', selectedExpenses);
      formData.append('transaction_date', date);


      const response = await axios.post(
        `${BASE_URL}/upload-payable-excel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      // setBalances(response.data.data);
      // handleClose();
      // Reset form fields
      setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const uploadRemittance = async () => {
    setCreateLoading(true);

    try {

      const formData = new FormData();
      formData.append('file', excelFile);
      formData.append('bank', selectedBanks);
      formData.append('customer_id', selectedCustomer);
      formData.append('transaction_date', selectedDate);
      //  formData.append('mode', selectedPaymentMode);
      formData.append('cheque_number', teller);


      const response = await axios.post(
        `${BASE_URL}/upload_remittance_payment_new`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      // setBalances(response.data.data);
      // handleClose();
      // Reset form fields
      setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  const [create, setCreate] = useState(false);

  const createRemitance = async () => {
    setCreate(true);

    try {

      const formData = new FormData();
      formData.append('bank', selectedBanks);
      formData.append('customer_id', selectedCustomer);
      formData.append('transaction_date', date);
      formData.append('mode', selectedPaymentMode);
      formData.append('cheque_number', teller);
      formData.append('description', description);
      formData.append('amount', incomeAmount);


      const response = await axios.post(
        `${BASE_URL}/save-casual-payment`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      // setBalances(response.data.data);
      // handleClose();
      // Reset form fields
      //  setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreate(false);
    }
  };
  const uploadStatements = async () => {
    setCreateLoading(true);

    try {

      const formData = new FormData();
      formData.append('file', selectedImagesss);
      formData.append('payable', selectedPayable);
      formData.append('expense', selectedExpenses);
      formData.append('transaction_date', date);
      formData.append('beneficiary_id', selectedBeneficiary.value);


      const response = await axios.post(
        `${BASE_URL}/upload-beneficiary-payable-excel`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      // setBalances(response.data.data);
      // handleClose();
      // Reset form fields
      setSelectedImagesss("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };


  return (
    <div className={classes.entnav22}>
      <NavLink to="/accounting">  <img src={logo} alt="Logo" className={classes.logo} /></NavLink>

      <div className={`${classes.headerNav} ${classes.desktopOnly}`}>
        {filteredNavItems.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          const hasDropdown = dropdownMenus[item.label];

          // Filter dropdown items based on permissions
          const filteredDropdownItems = hasDropdown
            ? dropdownMenus[item.label].filter((sub) => {
              if (item.label === 'Accounting') {
                // Accounting requires specific permissions for each submenu
                return permissions.includes(sub.permission);
              } else {
                // Other menus still rely on their parent-level permission
                return permissions.includes(sub.permission);
              }
            })
            : [];

          return hasDropdown && filteredDropdownItems.length > 0 ? (
            <div
              key={item.label}
              className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
            >
              <div
                className={classes.dshbrdnavMain}
                onClick={() =>
                  setOpenDropdown(openDropdown === item.label ? null : item.label)
                }
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p
                  className={isActive ? classes.activeText : ''}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {item.label}
                </p>
              </div>
              {openDropdown === item.label && (
                <div className={classes.dropdown}>
                  {filteredDropdownItems.map((sub, index) =>
                    sub.children ? (
                      // Handle nested dropdowns with children
                      <div key={index} className={classes.dropdownWithSub}>
                        <span className={classes.dropdownItem}>{sub.label}</span>
                        <div className={classes.subDropdown}>
                          {sub.children.map((child, cIndex) => {
                            if (child.isUploadRemittanceExcel) {
                              return (
                                <div
                                  key={cIndex}
                                  className={classes.dropdownItem}
                                  onClick={() => {
                                    setShowRemittanceExcelModal(true);
                                    setOpenDropdown(null);
                                  }}
                                >
                                  {child.label}
                                </div>
                              );
                            }
                            if (child.isRemittanceModal) {
                              return (
                                <div
                                  key={cIndex}
                                  className={classes.dropdownItem}
                                  onClick={() => {
                                    setShowRemittanceModal(true);
                                    setOpenDropdown(null);
                                  }}
                                >
                                  {child.label}
                                </div>
                              );
                            }
                            return (
                              <NavLink
                                key={cIndex}
                                to={child.path}
                                onClick={() => setOpenDropdown(null)}
                                className={({ isActive }) =>
                                  `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                                }
                              >
                                {child.label}
                              </NavLink>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      // Handle direct menu items (including remittance modals)
                      <div key={index}>
                        {sub.isUploadPayableModal ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              handleOpenUploadType();
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.isUploadRemittanceExcel ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              setShowRemittanceExcelModal(true);
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.isRemittanceModal ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              setShowRemittanceModal(true);
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.isModal ? (
                          <div
                            className={classes.dropdownItem}
                            onClick={() => {
                              setShowLoanModal(true);
                              setOpenDropdown(null);
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : sub.customAction ? (   // ✅ Handles items like Monthly Remittance Upload - Excel
                          <div
                            key={index}
                            className={classes.dropdownItem}
                            onClick={() => {
                              sub.customAction();       // 👈 call the function defined in dropdownMenus
                              setTimeout(() => setOpenDropdown(null), 100); // optional delay to prevent premature close
                            }}
                          >
                            {sub.label}
                          </div>
                        ) : (
                          <NavLink
                            to={sub.path}
                            onClick={() => setOpenDropdown(null)}
                            className={({ isActive }) =>
                              `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ""}`
                            }
                          >
                            {sub.label}
                          </NavLink>
                        )}
                      </div>
                    )
                  )}

                </div>
              )}

            </div>
          ) : (
            <Link to={item.path} key={item.label} className={classes.link}>
              <div
                className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''}`}
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
              </div>
            </Link>
          );
        })}
      </div>
      <Modal show={showTypeModal} onHide={handleCloseTypeModal} centered style={{ zIndex: 9999 }}>
        <Modal.Header closeButton>
          <Modal.Title>Select Payable Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-2">
            <Button className={classes.sabtn} onClick={() => handleSelectType("Salary")}>
              Salary Payable
            </Button>
            <Button className={classes.btnpayab} onClick={() => handleSelectType("Pension")}>
              Pension / PAYE Payable
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Step 2: Upload Form */}
      <Modal show={showFormModal} onHide={handleCloseFormModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {payableType === "Salary"
              ? "Upload Salary Payable"
              : "Upload Pension / PAYE Payable"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              console.log("Submit", payableType);
              handleCloseFormModal();
            }}
          >
            {payableType === "Salary" && (
              <a style={{}} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                <Button
                  className={classes.btntemp}
                  style={{ width: 200, height: "30px", padding: "0", borderRadius: 5, marginBottom: 10 }}  >
                  Download Template
                </Button>
              </a>
            )}
            {payableType === "Pension" && (
              <a style={{ marginLeft: 10 }} href={`https://account-api.patna.ng/api/v1/download-payable-excel`} download>
                <Button
                  className={classes.btntemp}
                  style={{ width: 200, height: "30px", padding: "0", borderRadius: 5, marginBottom: 10 }} variant='success' >
                  Download Template
                </Button>
              </a>
            )}
            <Modal.Footer />
            <Form.Group className="mb-3">

              <Form.Label>Payable Account</Form.Label>
              <Select isLoading={loading} options={debit2} onChange={handlePayables} placeholder='Select Payable Account'
                menuPortalTarget={document.body}
                styles={{
                  width: '80vh',

                  menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh' }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '300px',
                    maxWidth: '700px',
                    overflowY: 'auto',
                    marginLeft: '20px',
                  }),
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Expenses Account</Form.Label>
              <Select isLoading={loading} options={debit1} onChange={handledExpenses} placeholder='Select Expenses Account'
                menuPortalTarget={document.body}
                styles={{

                  menuPortal: (base) => ({ ...base, zIndex: 9999, width: '40vh' }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '300px',
                    maxWidth: '700px',
                    overflowY: 'auto',
                  }),
                }}
              />
            </Form.Group>

            {payableType === "Pension" && (
              <Form.Group className="mb-3">
                <Form.Label>Select PFA/Tax Agents</Form.Label>
                <Select
                  value={selectedBeneficiary}
                  onChange={setSelectedBeneficiary}
                  options={tableData}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: '300px',
                      maxWidth: '300px',
                      overflowY: 'auto',
                    }),
                  }}
                />
              </Form.Group>
            )}

            <Form.Group className="mb-3">
              <Form.Label>Date</Form.Label>
              <Form.Control type="date" min={minDate}
                max={maxDate} value={date} onChange={(e) => setDate(e.target.value)} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>File</Form.Label>
              <Form.Control
                type="file"
                placeholder="Choose file"
                accept=".xlsx"
                onChange={handleImageChangessss}

              />
            </Form.Group>



            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={handleCloseFormModal}>
                Cancel
              </Button>
              <Button style={{ background: "linear-gradient(to bottom, var(--primary-color), var(--light-primary))" }} onClick={payableType === "Salary" ? uploadStatement : uploadStatements}  >
                {createLoading ? (
                  <>
                    <Spinner size='sm' />
                    <span style={{ marginLeft: '5px' }}>Uploading, Please wait...</span>
                  </>
                ) : (
                  "Upload"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={showCustomer} onHide={handleCloseCustomer} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Loan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ marginTop: 20 }}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">

              {/* <div style={{ marginTop: 10 }}>
                                    
                                              <label for="example-text-input" style={{textAlign: "right"}}>Select Account</label>
                                              <div style={{width:'100%'}}>
                                                <Select
                                                    value={banks.find((b) => b.value === selectedBank) || null}
                                                  onChange={(selectedOption) => handleBankChange(selectedOption)}
                                                  options={banks}
                                                  menuPortalTarget={document.body}
                                                  styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    menu: (provided) => ({
                                                      ...provided,
                                                      maxHeight: '400px',
                                                      overflowY: 'auto',
                                                    }),
                                                  }}
                                                />
                                              </div>
                                             
                                    
                                      </div> */}



              <div style={{ marginTop: 10 }} >
                {/* <div className={`${classes.formFlex} ${classes.formFlex2}`}> */}
                <label for="example-text-input" style={{ textAlign: "right" }}>Loan Type</label>
                <div style={{ width: '100%' }}>
                  <Select
                    // value={selectedLoan}
                    value={loans.find((l) => l.value === selectedLoan) || null}
                    onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                    options={loans}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: '400px',
                        overflowY: 'auto',
                      }),
                    }}
                  />
                </div>
                {/* </div> */}
              </div>

              <div style={{ marginTop: 10, marginLeft: 7 }}>
                <Form.Label>File
                  {/* <span style={{marginLeft: 8}}><a href="https://account-api.patna.ng/api/v1/download-staff-loan" download>
                           <span style={{cursor: "pointer", fontStyle: "italic" }}>Downoload Template</span>
                          </a>
                                    </span> */}
                </Form.Label>
                <Form.Control
                  type="file"
                  placeholder="Choose file"
                  accept=".xlsx, .xls"
                  onChange={handleImageChange}
                />
              </div>

            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseCustomer}>
            Go back
          </Button>
          <Button variant="success"
            onClick={createLoans}
          >
            {loading ? (
              <>
                <Spinner size='sm' />
                <span style={{ marginLeft: '5px' }}>Uploading Loan, Please wait...</span>
              </>
            ) : (
              "Upload Loan"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal size='lg' show={showLoanModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Loan Disbursement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <p style={{
              fontWeight: 'bold',
              marginBottom: 10,
              fontSize: 16,
              color: '#000'
            }}>Upload Loan Disbursement</p>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              // justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 10,
              marginBottom: 10
            }}>
              <div>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="download-tooltip">
                      Click here to download template
                    </Tooltip>
                  }
                >
                  <a href="https://account-api.patna.ng/api/v1/download-staff-loan-disbursement" download>
                    <div style={{
                      width: 200,
                      height: 40,
                      borderRadius: 8,
                      backgroundColor: '#fff',
                      border: '1px solid rgb(187, 183, 183)',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <p style={{
                        marginTop: -3,

                        color: '#000'
                      }}>Download Template</p>
                    </div>
                    {/* <i className="fa fa-download" style={{ color: "#3770ab",  borderColor: "#3770ab", borderRadius: 5, fontSize: 23, cursor: "pointer", marginTop: 7 }}></i> */}
                  </a>
                </OverlayTrigger>
              </div>
              <div>
                <OverlayTrigger
                  placement="top"
                  className={classes.btndf1}
                  overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to upload loan</Tooltip>}
                >
                  <Button variant='success' className={classes.btn2} onClick={handleShowCustomer} >
                    Upload Loan
                  </Button>
                </OverlayTrigger>
              </div>

              {/* <Button variant="success" onClick={handleCreate} className={classes.btn1}>  Create New Loan  </Button> */}
            </div>
            <Modal.Footer />
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="transactionDate">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Transaction Date
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date"
                      value={selectedDatess}
                      onChange={handleDateChangess}
                      min={minDate}
                      max={maxDate}
                      required
                      style={{ flex: 1 }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="member">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Member
                    </Form.Label>
                    <div style={{ flex: 1 }}>
                      <Select
                        onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                        options={selectOptions}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: '300px',
                            overflowY: 'auto',
                          }),
                          control: (provided) => ({
                            ...provided,
                            width: '100%',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="loanType">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Loan Type
                    </Form.Label>
                    <div style={{ flex: 1 }}>
                      <Select
                        onChange={(selectedOption) => handleLoanTypeChange(selectedOption)}
                        options={loans}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: '200px',
                            overflowY: 'auto',
                          }),
                          control: (provided) => ({
                            ...provided,
                            width: '100%',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="principalAmount">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Principal Amount
                    </Form.Label>
                    <CurrencyInput
                      name="principal amount"
                      decimalsLimit={2}
                      className="form-control"
                      value={principalAmount}
                      onValueChange={handleValueChange}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="loanInterest">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Loan Interest
                    </Form.Label>
                    <CurrencyInput
                      name="loan interest"
                      decimalsLimit={2}
                      className="form-control"
                      value={loanInterest}
                      disabled
                      onValueChange={handleValueChange1}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="interest">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Interest
                    </Form.Label>
                    <CurrencyInput
                      name="interest"
                      decimalsLimit={2}
                      className="form-control"
                      value={interest}
                      disabled
                      onValueChange={handleValueChange2}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="totalRepayment">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Total Repayment
                    </Form.Label>
                    <CurrencyInput
                      name="total repayment"
                      decimalsLimit={2}
                      className="form-control"
                      value={totalRepayment}
                      disabled
                      onValueChange={handleValueChange3}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="duration">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Duration (Months)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="duration"
                      value={duration}
                      onChange={(e) => setDuration(e.target.value)}
                      required
                      style={{ flex: 1 }}
                    />
                  </div>
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="monthlyDeduction">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Monthly Deduction
                    </Form.Label>
                    <CurrencyInput
                      name="monthly deduction"
                      decimalsLimit={2}
                      className="form-control"
                      value={monthlyDeduction}
                      disabled
                      onValueChange={handleValueChange4}
                      style={{ flex: 1, textAlign: 'right', border: '1px solid #e4e4e4' }}
                    />
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3" controlId="selectBank">
                  <div className="d-flex align-items-center">
                    <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                      Select Bank
                    </Form.Label>
                    <div style={{ flex: 1 }}>
                      <Select
                        value={selectedBanks}
                        onChange={(selectedOption) => handleBankChange(selectedOption)}
                        options={banks}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: '200px',
                            overflowY: 'auto',
                          }),
                          control: (provided) => ({
                            ...provided,
                            width: '100%',
                          }),
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>

            {/* Commented-out Cheque No. field */}
            {/* <div className="row">
        <div className="col-md-6">
          <Form.Group className="mb-3" controlId="chequeNo">
            <div className="d-flex align-items-center">
              <Form.Label style={{ width: '150px', textAlign: 'right', marginRight: '10px' }}>
                Cheque No.
              </Form.Label>
              <Form.Control
                type="text"
                name="cheque no"
                value={cheque}
                onChange={(e) => setCheque(e.target.value)}
                required
                style={{ flex: 1 }}
              />
            </div>
          </Form.Group>
        </div>
      </div> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button style={{ borderRadius: 0 }} variant='success' onClick={createLoan} >
            {createLoading ? (
              <>
                <Spinner size='sm' />
                <span style={{ marginLeft: '5px' }}>Creating, Please wait...</span>
              </>
            ) : (
              "Create New Loan"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={showRemittanceModal} onHide={() => setShowRemittanceModal(false)} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16, fontWeight: 'bold' }}>Add Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Row 1 */}
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Transaction Date
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    style={{ fontSize: 14 }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Customer
                  </Form.Label>
                  <Select
                    onChange={handleCustomerChange}
                    options={cus}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        fontSize: 14,
                        minHeight: 38,
                      }),
                      singleValue: (base) => ({ ...base, fontSize: 14 }),
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Outstanding
                  </Form.Label>
                  <CurrencyInput
                    name="amount"
                    decimalsLimit={2}
                    className="form-control"
                    value={outstanding}
                    disabled
                    style={{
                      textAlign: "right",
                      border: "1px solid #e4e4e4",
                      fontSize: 14,
                    }}
                  />
                </Form.Group>
              </Col>


            </Row>

            {/* Row 2 */}
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Description
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={1}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ fontSize: 14 }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Payment Mode
                  </Form.Label>
                  <Form.Select
                    value={selectedPaymentMode}
                    onChange={handlePaymentModeChange}
                    style={{ fontSize: 14 }}
                  >
                    <option value="">Select Mode</option>
                    {paymentMethod.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Bank
                  </Form.Label>
                  <Select
                    onChange={handlePaymentChange}
                    options={
                      selectedPaymentMode === "1" || selectedPaymentMode === "3"
                        ? debit3
                        : selectedPaymentMode === "2" || selectedPaymentMode === "4"
                          ? debit4
                          : debit3
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      control: (base) => ({
                        ...base,
                        fontSize: 14,
                        minHeight: 38,
                      }),
                      singleValue: (base) => ({ ...base, fontSize: 14 }),
                    }}
                  />
                </Form.Group>
              </Col>

            </Row>

            {/* Row 3 */}
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Amount
                  </Form.Label>
                  <CurrencyInput
                    name="amount"
                    decimalsLimit={2}
                    className="form-control"
                    value={incomeAmount}
                    onValueChange={handleValueChanges}
                    style={{
                      textAlign: "right",
                      border: "1px solid #e4e4e4",
                      fontSize: 14,
                    }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label className={classes.formLabelCustom} style={{ fontSize: 14 }}>
                    Cheque / Teller No
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={teller}
                    onChange={(e) => setTeller(e.target.value)}
                    style={{ fontSize: 14 }}
                  />
                </Form.Group>
              </Col>


            </Row>
          </Form>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className={classes.btn1} onClick={setShowRemittanceModal}> Cancel</Button>
          <Button className={classes.btnss} variant='primary'
            onClick={createRemitance} >
            Make Payment

          </Button>

        </Modal.Footer>
        {create && (
          <div className={classes.overlay}>
            <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
          </div>
        )}
      </Modal>
      <RemitanceUpload isOpen={showRemittanceExcelModal} onClose={() => setShowRemittanceExcelModal(false)} animation={false} />
      <Modal size='lg' >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 16, fontWeight: 'bold' }}>Remittance - Excel Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Row 1 */}
            <Row className="g-3">
              <Col md={4} sm={12}>
                <Form.Group controlId="transactionDate" className="mb-3">
                  <Form.Label className={classes.formLabelCustom}>Transaction Date</Form.Label>
                  <Form.Control
                    type="date"
                    onChange={handleDateChange}
                    value={selectedDate}
                  // min={minDate}
                  // max={maxDate}
                  />
                </Form.Group>
              </Col>

              <Col md={4} sm={12}>
                <Form.Group controlId="customer" className="mb-3">
                  <Form.Label className={classes.formLabelCustom}>Customer</Form.Label>
                  <Select
                    onChange={handleCustomerChange}
                    options={cus}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Form.Group>
              </Col>



              {/* <Col md={4} sm={12}>
          <Form.Group controlId="paymentMode" className="mb-3">
            <Form.Label className={classes.formLabelCustom}>Payment Mode</Form.Label>
            <Form.Select
              value={selectedPaymentMode}
              onChange={handlePaymentModeChange}
              style={{ fontSize: 14 }}
            >
              <option value="">Select Mode</option>
              {paymentMethod.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col> */}
              <Col md={4} sm={12}>
                <Form.Group controlId="bank" className="mb-3">
                  <Form.Label className={classes.formLabelCustom}>Bank</Form.Label>
                  <Select
                    onChange={handlePaymentChange}
                    options={
                      debit3
                    }
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Row 2 */}
            <Row className="g-3">


              <Col md={4} sm={12}>
                <Form.Group controlId="tellerNo" className="mb-3">
                  <Form.Label className={classes.formLabelCustom}>Cheque/Teller No</Form.Label>
                  <Form.Control
                    type="text"
                    value={teller}
                    onChange={(e) => setTeller(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={4} sm={12}>
                <Form.Group controlId="uploadExcel" className="mb-3">
                  <Form.Label className={classes.formLabelCustom}>Upload Excel File</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".xls,.xlsx"
                    onChange={(e) => setExcelFile(e.target.files[0])}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Modal.Footer />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" className={classes.btn1} onClick={() => setShowRemittanceExcelModal(false)}>Cancel</Button>
          <Button className={classes.btnss} variant="primary" onClick={uploadRemittance}>
            Upload
          </Button>
        </Modal.Footer>
        {createLoading && (
          <div className={classes.overlay}>
            <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
          </div>
        )}

      </Modal>

      {/* User section */}
      <div className={`${classes.user} ${classes.desktopOnly}`}>
        {/* <img src={usrnoti} className={classes.bellnoti} alt="Notification" /> */}
        <div className={classes.userProfile} ref={userDropdownRef}>
          <div
            className={classes.userAvatar}
            onClick={() => setUserDropdownOpen(!userDropdownOpen)}
          >
            <p className={classes.usrnm}>
              {initials}
            </p>
          </div>

          {/* User dropdown menu */}
          {userDropdownOpen && (
            <div className={classes.userDropdown}>
              <div className={classes.userInfo}>
                <p className={classes.userName}>{user || 'User'}</p>
                <p className={classes.userEmail}>{userEmail || 'user@example.com'}</p>
              </div>
              <div className={classes.dropdownDivider}></div>
              <button
                type="button"
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  setShowChangePassword(true);
                  setUserDropdownOpen(false);
                }}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Change Password
              </button>

              <button onClick={() => navigate("/welcome")}
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
              >
                <img src={stngs} alt="Settings" className={classes.dropdownIcon} />
                Switch Account
              </button>

              <button
                className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                onClick={() => {
                  handleLogout();
                  setUserDropdownOpen(false);
                  // Redirect to signin page after logout
                  // window.location.href = "/signin";
                }}
              >
                <img src={stngs} alt="Logout" className={classes.dropdownIcon} />
                Logout
              </button>
            </div>
          )}

        </div>
      </div>
      <div className={classes.mobileOnly}>
        <button
          className={classes.hamburgerBtn}
          onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaRegTimesCircle /> : <CiMenuFries />}
        </button>
      </div>
      {isMobileMenuOpen && (
        <div className={classes.mobileMenu}>
          <div className={classes.mobileMenuContent}>
            {/* All Navigation Links */}
            <div className={classes.mobileNav}>
              {filteredNavItems.map((item) => {
                const isActive = location.pathname.startsWith(item.path);
                const hasDropdown = dropdownMenus[item.label];

                // filter submenu permissions same as desktop
                const filteredDropdownItems = hasDropdown
                  ? dropdownMenus[item.label].filter((sub) => {
                    if (item.label === "Accounting") {
                      return permissions.includes(sub.permission);
                    } else {
                      return permissions.includes(sub.permission);
                    }
                  })
                  : [];

                return hasDropdown && filteredDropdownItems.length > 0 ? (
                  <div key={item.label} className={classes.mobileNavGroup}>
                    {/* parent clickable */}
                    <div
                      className={`${classes.mobileNavItem} ${isActive ? classes.activeDropdown : ""
                        }`}
                      onClick={() =>
                        setOpenDropdown(openDropdown === item.label ? null : item.label)
                      }
                    >
                      {item.label}
                    </div>

                    {/* submenu collapsible */}
                    {openDropdown === item.label && (
                      <div className={classes.mobileSubmenu}>
                        {filteredDropdownItems.map((sub, index) =>
                          sub.isUploadPayableModal ? (
                            <div
                              key={index}
                              style={{ cursor: "pointer" }}
                              className={classes.mobileSubmenuItem}
                              onClick={() => {
                                handleOpenUploadType();
                                setOpenDropdown(null);
                                setMobileMenuOpen(false);
                              }}
                            >
                              {sub.label}
                            </div>
                          ) : sub.isModal ? (
                            <div
                              key={index}
                              className={classes.mobileSubmenuItem}
                              onClick={() => {
                                setShowLoanModal(true);
                                setOpenDropdown(null);
                                setMobileMenuOpen(false);
                              }}
                            >
                              {sub.label}
                            </div>
                          ) : (
                            <NavLink
                              key={index}
                              to={sub.path}
                              onClick={() => {
                                setOpenDropdown(null);
                                setMobileMenuOpen(false);
                              }}
                              className={({ isActive }) =>
                                `${classes.mobileSubmenuItem} ${isActive ? classes.activeDropdown : ""
                                }`
                              }
                            >
                              {sub.label}
                            </NavLink>
                          )
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <NavLink
                    key={item.label}
                    to={item.path}
                    onClick={() => setMobileMenuOpen(false)}
                    className={({ isActive }) =>
                      `${classes.mobileNavItem} ${isActive ? classes.activeDropdown : ""}`
                    }
                  >
                    {item.label}
                  </NavLink>
                );
              })}

            </div>

            {/* Profile Section inside mobile menu */}
            <div className={classes.mobileProfile}>
              <p className={classes.userName}>{user || "User"}</p>
              <p className={classes.userEmail}>{userEmail || "user@example.com"}</p>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  setShowChangePassword(true);
                  setMobileMenuOpen(false);
                }}
              >
                Change Password
              </button>

              <button
                className={classes.dropdownItemm}
                onClick={() => {
                  handleLogout();
                  setMobileMenuOpen(false);
                }}
              >
                Logout
              </button>
            </div>
          </div>

        </div>
      )}
      <JournalModal
        isOpen={openJournalModal}
        onClose={() => setOpenJournalModal(false)}
      />

    </div>
  );
}
